class ProductBuyBar extends HTMLElement {
  connectedCallback() {
    this.mainForm = document.getElementById(this.dataset.productFormId);
    if (!this.mainForm) return;
    this.mainButton = this.mainForm.querySelector('[name="add"]');
    if (!this.mainButton) return;
    this.onBarSubmit = (event) => {
        event.preventDefault();
      event.stopImmediatePropagation();
      if (!this.mainButton.disabled && this.mainButton.getAttribute('aria-disabled') !== 'true') this.mainButton.click();
    };
    this.addEventListener('submit', this.onBarSubmit, true);
    this.syncButton = () => {
      const button = this.querySelector('[name="add"]');
      if (!button) return;
      button.disabled = this.mainButton.disabled || this.mainButton.getAttribute('aria-disabled') === 'true';
      const label = button.querySelector('span');
      const mainLabel = this.mainButton.querySelector('span');
      if (label && mainLabel && label.textContent !== mainLabel.textContent) label.textContent = mainLabel.textContent;
    };
    this.buttonObserver = new MutationObserver(this.syncButton);
    this.buttonObserver.observe(this.mainButton, {attributes:true, childList:true, subtree:true, characterData:true});
    this.barObserver = new MutationObserver(this.syncButton);
    this.barObserver.observe(this, {childList:true, subtree:true});
    this.syncButton();
    const footer = document.querySelector('footer.footer');
    this.updateVisibility = () => {
      const buttonRect = this.mainButton.getBoundingClientRect();
      const footerVisible = footer && footer.getBoundingClientRect().top < window.innerHeight;
      const visible = buttonRect.bottom < 0 && !footerVisible;
      this.classList.toggle('show', visible);
      this.inert = !visible;
      this.setAttribute('aria-hidden', String(!visible));
    };
    this.visibilityObserver = new IntersectionObserver(this.updateVisibility);
    this.visibilityObserver.observe(this.mainButton);
    if (footer) this.visibilityObserver.observe(footer);
    window.addEventListener('resize', this.updateVisibility);
    this.updateVisibility();
  }
  disconnectedCallback() {
    this.removeEventListener('submit', this.onBarSubmit, true);
    this.buttonObserver?.disconnect();
    this.barObserver?.disconnect();
    this.visibilityObserver?.disconnect();
    window.removeEventListener('resize', this.updateVisibility);
  }
}
if (!customElements.get('product-buy-bar')) customElements.define('product-buy-bar', ProductBuyBar);

class UpsellCard extends HTMLElement {
  constructor() {
    super();
    this.select = this.querySelector('select');
    this.image = this.querySelector('.card-media img');

    if (this.select) {
      this.select.addEventListener('change', (event) => {
        const selectedOption = event.target.options[event.target.selectedIndex];
        const newImgSrc = selectedOption.getAttribute('data-variant-img-src');
        if (newImgSrc) { this.updateImage(newImgSrc) }
      });
    }
  }

  updateImage(newImgSrc) {
    if (this.image && newImgSrc) {
      // Sanitize and validate URL to prevent XSS
      // Remove any whitespace and HTML entities
      const sanitized = String(newImgSrc).trim().replace(/[\s<>"']/g, '');

      // Reject dangerous protocols (check anywhere in string, not just start)
      const dangerousProtocols = /^(javascript|data|vbscript|file|about):/i;
      if (dangerousProtocols.test(sanitized)) {
        return; // Reject dangerous URLs
      }

      try {
        // Try to parse as absolute URL
        const url = new URL(sanitized, window.location.origin);
        // Only allow http and https protocols
        if (url.protocol === 'http:' || url.protocol === 'https:') {
          // Use the properly constructed URL to prevent any encoding issues
          this.image.src = url.href;
        }
      } catch (e) {
        // If URL parsing fails, it's likely a relative URL
        // Additional validation: ensure it doesn't contain dangerous patterns
        if (!sanitized.includes('javascript:') &&
            !sanitized.includes('data:') &&
            !sanitized.includes('vbscript:') &&
            !sanitized.includes('<') &&
            !sanitized.includes('>')) {
          // For relative URLs, ensure proper encoding
          this.image.src = sanitized;
        }
      }
    }
  }
}

customElements.define('upsell-card', UpsellCard);